/**
 * The `contextJobsiteId` for `useSearch` from a job picker value, or undefined
 * unless it is one job: All jobs is 0, and the no-job and global values are
 * negative. Kept out of `useSearch.ts`, so a test that mocks that module
 * doesn't have to supply it.
 */
export function contextJobsiteIdOf(jobId: number | undefined): string | undefined {
    return jobId !== undefined && Number.isInteger(jobId) && jobId > 0 ? String(jobId) : undefined;
}
